import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { GetFeatureCandidateGoodsListService } from './api-services/get-feature-candidate-goods-list.service';
import { GetRequestInfoListService } from './api-services/get-request-info-list.service';
import { UpdateFeatureRequestBuyerService } from './api-services/update-feature-request-buyer.service';
import { GetRequestBuyerService } from './api-services/get-request-buyer.service';
import { GetDelivCatalogIdByOrderCodeService } from './api-services/get-deliv-catalog-id-by-order-code.service';
import { GetOrderCodeByDelivCatalogIdService } from './api-services/get-order-code-by-deliv-catalog-id.service';
import { GetOrderCodeClassListService } from './api-services/get-order-code-class-list.service';
import { GetOrderCodeMediumListService } from './api-services/get-order-code-medium-list.service';

import { KYMW7006Component } from './kymw7006.component';

/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面 モジュール設定クラス
 *
 * @export KYMW7006Module
 * @class KYMW7006Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW7006Component],
  providers: [
    GetFeatureCandidateGoodsListService,
    GetRequestInfoListService,
    UpdateFeatureRequestBuyerService,
    GetRequestBuyerService,
    GetDelivCatalogIdByOrderCodeService,
    GetOrderCodeByDelivCatalogIdService,
    GetOrderCodeClassListService,
    GetOrderCodeMediumListService,
  ],
})
export class KYMW7006Module {}
